import { debug } from 'util';

export default class SoundController {
  constructor({ game }) {
    this.game = game;
    this.sounds = {};
    this.sprites = {};
    const isMuted = false;
    this._allowMusic = !isMuted;
    this._allowEffects = !isMuted;
    this.backgroundMusic = { id: null, volume: SoundController.TITLEMUSIC_VOLUME };
    this.isPlayingButtonSFX = false;
    Object.defineProperty(this, 'allowMusic', {
      get: function() {
        return this._allowMusic;
      },
      set: function(value) {
        this._allowMusic = value;
        this._allowMusic ? this.playBackgroundMusic() : this.pauseBackgroundMusic();
      },
    });

    Object.defineProperty(this, 'allowEffects', {
      get: function() {
        return this._allowEffects;
      },
      set: function(value) {
        this._allowEffects = value;
        for (let i in this.sounds) {
          if (i != this.backgroundMusic.id) this.sounds[i].mute = this._allowEffects == false;
        }
      },
    });
  }

  /*
  ================================================================================================
    This may need finesse, been asked to pause all sounds on game pause, have a feeling this will need filters :)
  ================================================================================================
  */
  pauseAll() {
    this.game.sound.pauseAll();
  }

  resumeAll() {
    this.game.sound.resumeAll();
  }

  /**
   * Touchlock and AudioContext handling
   */
  touchLock() {
    /**
     * Called from load state. Will handle touch locking here
     */
    if (this.game.sound.usingWebAudio && this.game.sound.context.state === 'suspended') {
      console.info('AudioContext is suspended');
      this.game.sound.setTouchLock(); // doesn't seem to do anything
      this.isTouchLocked = true;
    }
  }

  checkAudioContext() {
    if (this.isTouchLocked && this.game.sound.usingWebAudio) {
      console.info('AudioContext attempting resume');
      this.game.sound.context.resume().then(() => {
        console.info('AudioContext resumed successfully');
        this.isTouchLocked = this.game.sound.context.state === 'suspended';
      });
    }
  }

  /**
   * End Touchlock and AudioContext handling
   */

  /*
  =====================================================================
    ADD / REMOVE SOUNDS
  =====================================================================
  */

  addSound(id, assetKey) {
    // console.log('>> addSound', id, assetKey);
    this.sounds[id] = this.game.add.audio(assetKey);
  }

  removeSound(id, assetKey) {
    if (this.sounds[id]) {
      this.sounds[id].destroy();
      this.game.cache.removeSound(assetKey);
    }
  }

  soundsAreDecoded() {
    for (var i in this.sounds) {
      if (this.sounds[i].isDecoded === false) {
        return false;
      }
    }

    return true;
  }

  /*
  =====================================================================
    ADD / REMOVE AUDIO SPRITES
  =====================================================================
  */

  addAudioSprite({ id }) {
    // console.log('>> addAudioSprite', id);
    if (this.game.cache.checkSoundKey(id)) {
      this.sprites[id] = this.game.add.audioSprite(id);
    }

    // console.log('Add audiosprite', id, this.sprites);

    // this.sprites[id].allowMultiple = true;
  }

  removeAudioSprite({ id }) {
    if (this.sprites[id]) {
      Object.keys(this.sprites[id].sounds).forEach((key) => {
        this.sprites[id].sounds[key].destroy();
        this.game.cache.removeSound(key);
      });

      delete this.sprites[id];
    }
  }

  audioSpritesAreDecoded() {
    for (const sprite in this.sprites) {
      for (const s in sprite.sounds) {
        if (!s.isDecoded) {
          return false;
        }
      }
    }
    return true;
  }

  sfxExists(id, spriteID) {
    const exists = this.sprites[spriteID] && this.sprites[spriteID].sounds[id];
    if (!exists) {
      console.warn(
        'Cant find ' +
          id +
          ' in audiosprite ' +
          spriteID +
          ', has it been added? (config.json and assetpack)'
      );
      return false;
    }
    return true;
  }

  playButtonSFX(id, opts = {}) {
    /*
         *  NOTE - set to wait until button sfx is complete until it plays the next one
        */
    const isMuted = false;
    // console.log(
    //     'playButtonSFX',
    //     id,
    //     ' | isMuted',
    //     isMuted,
    //     ' | isDesktop',
    //     Phaser.Device.desktop,
    //     ' | isPlayingButtonSFX',
    //     this.isPlayingButtonSFX,
    //     ' | this.game.paused',
    //     this.game.paused
    // );
    if (!isMuted && Phaser.Device.desktop && (!this.isPlayingButtonSFX || this.game.paused)) {
      opts.spriteID = GEL_UI_SFX;
      if (this.sfxExists(id, GEL_UI_SFX)) {
        this.isPlayingButtonSFX = this.playSpriteSFX(id, opts);

        if (this.game.paused) {
          this.isPlayingButtonSFX = false;
        } else {
          if (this.isPlayingButtonSFX) {
            // console.log('playButtonSFX', id);
            const soundObj = this.sprites[GEL_UI_SFX].sounds[id];
            soundObj.onStop.addOnce(this.playButtonSFXComplete, this);
          }
        }
        // const soundObj = this.sprites[GEL_UI_SFX].sounds[id];
        // soundObj.onStop.addOnce(this.playButtonSFXComplete, this);

        // this.game.time.events.add(200, this.playButtonSFXComplete, this).autoDestroy = true;
      }
    }
  }

  playButtonSFXComplete() {
    // console.log('playButtonSFXComplete');
    this.isPlayingButtonSFX = false;
  }

  playUiSFX(id, opts = {}) {
    //opts.spriteID = UI_SFX_BASE;
    if (this.sprites[opts.spriteID] && !this.sprites[opts.spriteID].sounds[id]) {
      opts.spriteID = UI_SFX_EXTRA;
    }
    this.playSpriteSFX(id, opts);
  }

  stopUiSFX(id, opts = {}) {
    //opts.spriteID = UI_SFX_BASE;
    if (this.sprites[opts.spriteID] && !this.sprites[opts.spriteID].sounds[id]) {
      opts.spriteID = UI_SFX_EXTRA;
    }
    this.stopSFX(id, opts);
  }

  // prettier-ignore
  playSpriteSFX( id, opts = { volume: 1, loop: false, delay: null, onComplete: null, onCompleteScope: null, spriteID: "", })
  {
    // prettier-ignore
    let { volume = 1, loop = false, ignoreIfPlaying = false, delay = null, onComplete = null, onCompleteScope = null, spriteID = "" } = opts;

    if (this.sprites[spriteID]) {
      if (spriteID === "") {
        if (!this.sprites[spriteID].sounds[id]) {
          spriteID = "";
        }
      }
    }
    const exists = this.sfxExists(id, spriteID);


    if (!exists) {
      return false;
    }


    if (delay) {
      opts.delay = null;
      this.game.time.events.add(delay, this.playSpriteSFX, this, id, opts).autoDestroy = true;
      return true;
    }
    // if (this.isTouchLocked) {
    //     // console.log('playSpriteSFX : touch is locked ', id, opts);
    // }

    let sound = false;
    if (this._allowEffects && !this.isTouchLocked) {
      // if (this.sfxExists(id, spriteID)) {
      if (ignoreIfPlaying && this.sprites[spriteID].get(id).isPlaying) {
        return false;
      }
      this.sprites[spriteID].get(id).loop = loop;
      this.sprites[spriteID].get(id).markers[id].loop = loop; // need to set loop in markers also
      sound = this.sprites[spriteID].play(id, volume);
      // console.log('playSpriteSFX | id', id, ' | spriteID', spriteID, ' | volume', volume );
      if (onComplete) {
        const soundObj = this.sprites[spriteID].sounds[id];
        soundObj.onStop.addOnce(onComplete, onCompleteScope);
      }
      // } else {
      //     return false;
      // }
    } else if (onComplete) {
      /**
       * Fire the Signal immediately
       */
      const completeSignal = new Phaser.Signal();
      completeSignal.addOnce(onComplete, onCompleteScope);
      completeSignal.dispatch();
    } else {
      return false;
    }
    return sound;
  }

  // prettier-ignore
  playSFX( id, opts = { volume: 1, loop: false, delay: null, onComplete: null, onCompleteScope: null })
  {
    // prettier-ignore
    let { volume = 1, loop = false, ignoreIfPlaying = false, delay = null, onComplete = null, onCompleteScope = null } = opts;
    // console.log('playSFX | id', id );
    if (delay) {
      opts.delay = null;
      this.game.time.events.add(delay, this.playSpriteSFX, this, id, opts).autoDestroy = true;
      return true;
    }

    let sound = false;
    if (this._allowEffects && !this.isTouchLocked) {
      if (ignoreIfPlaying && this.sounds[id].isPlaying) {
        return false;
      }

      if (onComplete) {
        const soundObj = this.sounds[id];
        soundObj.onStop.addOnce(onComplete, onCompleteScope);
      }

      sound = this.sounds[id].play();
    } else if (onComplete) {
      /**
       * Fire the Signal immediately
       */
      const completeSignal = new Phaser.Signal();
      completeSignal.addOnce(onComplete, onCompleteScope);
      completeSignal.dispatch();
    } else {
      return false;
    }
    return sound;
  }

  // used to stop looping audio : loop is defined in audiosprite json now!!
  stopSFX(id, opts = { spriteID: '' }) {
    let { spriteID = '' } = opts;
    if (this.sprites[spriteID]) {
      if (spriteID === '') {
        if (!this.sprites[spriteID].sounds[id]) {
          spriteID = '';
        }
      } else {
        if (this.sfxExists(id, spriteID)) {
          this.sprites[spriteID].stop(id);
        }
      }
    } else {
      if (this.sounds[id]) {
        this.sounds[id].stop();
      }
    }
  }

  pauseSFX(id, opts = { spriteID: '' }) {
    let { spriteID = '' } = opts;
    if (this.sprites[spriteID]) {
      if (spriteID === '') {
        if (!this.sprites[spriteID].sounds[id]) {
          spriteID = '';
        }
      } else {
        if (this.sfxExists(id, spriteID)) {
          this.sprites[spriteID].sounds[id].pause();
        }
      }
    } else {
      if (this.sounds[id]) {
        this.sounds[id].pause();
      }
    }
  }

  resumeSFX(id, opts = { spriteID: '' }) {
    let { spriteID = '' } = opts;
    if (this.sprites[spriteID]) {
      if (spriteID === '') {
        if (!this.sprites[spriteID].sounds[id]) {
          spriteID = '';
        }
      } else {
        if (this.sfxExists(id, spriteID)) {
          this.sprites[spriteID].sounds[id].resume();
        }
      }
    } else {
      if (this.sounds[id]) {
        this.sounds[id].resume();
      }
    }
  }

  stopAllSFX() {
    for (const i in this.sprites) {
      this.sprites[i].stop();
    }
  }

  stopAllSFXExceptUi() {
    for (const i in this.sprites) {
      // if (i != UI_SFX_BASE) {
      //   this.sprites[i].stop();
      // }
    }
  }

  /**
   * End audiosprites
   */

  /**
   * Background Music
   */
  setBackgroundMusic(id, play) {
    // console.log('setBackgroundMusic', id);
    if (this.sounds[id]) {
      if (!this.sounds[id].isPlaying) {
        this.stopBackgroundMusic();
        this.backgroundMusic.id = id;
        if (play) {
          this.playBackgroundMusic();
        }
      }
    } else {
      //console.warn('Background music set to', id);
    }
  }

  stopBackgroundMusic() {
    const { id } = this.backgroundMusic;
    this.stopSound(id);
  }

  playBackgroundMusic() {
    const { id, volume } = this.backgroundMusic;
    const snd = this.sounds[id];
    if (snd) {
      // console.info('play', id, '| paused', snd.paused, '| playing', snd.isPlaying);
      if (this._allowMusic) {
        if (!snd.paused && snd.isPlaying) {
        } else if (!snd.paused && !snd.isPlaying) {
          console.log('hello');
          snd.play('', 0, 0, true);
          snd.fadeTo(1000, volume);
        } else if (snd.paused) {
          console.log('hello');
          snd.volume = 0;
          snd.resume();
          snd.fadeTo(500, volume);
        }
      }
    }
  }

  pauseBackgroundMusic() {
    const { id } = this.backgroundMusic;
    const snd = this.sounds[id];
    if (snd) {
      snd.pause();
    }
  }

  resumeBackgroundMusic() {
    const { id, volume } = this.backgroundMusic;
    const snd = this.sounds[id];
    if (snd) {
      if (this._allowMusic) {
        if (snd.paused) {
          snd.volume = 0;
          snd.resume();
          snd.fadeTo(500, volume);
        }
      }
    }
  }

  playSoundEffect(id, loop, volume, delay) {
    if (delay) {
      this.game.time.events.add(
        delay,
        this.playSoundEffect,
        this,
        id,
        loop,
        volume
      ).autoDestroy = true;
      return;
    }

    if (this._allowEffects) {
      if (this.sounds[id]) {
        this.playSound(id, loop, volume);
      } else {
        // console.warn(
        //     'Cant find sfx : ' + id + ', has it been added? (config.json and assetpack)'
        // );
      }
    }
  }

  playSound(id, loop, volume, onComplete, onCompleteScope, dontOverride) {
    if (this.sounds[id]) {
      if (dontOverride && this.sounds[id].isPlaying) {
        return;
      } else {
        this.sounds[id].play(null, 0, volume || 1, loop);
        if (onComplete) {
          this.sounds[id].onStop.addOnce(onComplete, onCompleteScope);
        }
      }
    } else {
      console.log('cannot find sound : ' + id);
    }
  }

  stopSound(id) {
    if (this.sounds[id]) {
      this.sounds[id].pausedPosition = 0;
      this.sounds[id].stop();
    }
  }

  isSoundPlaying(id) {
    if (this.sounds[id]) {
      return this.sounds[id].isPlaying;
    }
    return false;
  }

  stopAllSounds() {
    for (let i in this.sounds) {
      this.sounds[i].stop();
    }
  }

  setVolume(id, volume) {
    if (this.backgroundMusic.id == id) {
      this.backgroundMusic.volume = volume;
      this.sounds[id].fadeTo(1000, volume);
    } else {
      this.sounds[id].volume = volume;
    }
  }
}
SoundController.TITLEMUSIC_VOLUME = 0.7;



// WEBPACK FOOTER //
// ./js/app/controller/SoundController.js